import type { SkillCategory } from '../types';

export const skills: SkillCategory[] = [
  {
    id: 'frontend',
    nameKey: 'skills.categories.frontend',
    skills: [
      { name: 'React' },
      { name: 'TypeScript' },
      { name: 'JavaScript' },
      { name: 'Redux' },
      { name: 'Zustand' },
      { name: 'TanStack Query' },
      { name: 'Next.js' },
      { name: 'Vite' },
      { name: 'Tailwind CSS' },
      { name: 'shadcn/ui' },
      { name: 'AI SDK' },
      { name: 'HTML/CSS' },
      { name: 'Jest' },
      { name: 'React Testing Library' },
    ],
  },
  {
    id: 'backend',
    nameKey: 'skills.categories.backend',
    skills: [
      { name: 'Node.js' },
      { name: 'LoopBack 4' },
      { name: 'Java' },
      { name: 'Spring' },
      { name: 'Spring Batch' },
      { name: 'PostgreSQL' },
      { name: 'Kafka' },
      { name: 'JWT' },
      { name: 'JPA/JDBC' },
      { name: 'Flyway' },
      { name: 'Python' },
      { name: 'Kotlin' },
      { name: 'C#' },
    ],
  },
  {
    id: 'devops',
    nameKey: 'skills.categories.devops',
    skills: [
      { name: 'Git' },
      { name: 'AWS' },
      { name: 'Linux' },
      { name: 'Docker' },
      { name: 'Claude Code' },
      { name: 'Figma' },
      { name: 'Atlassian Jira' },
      { name: 'Atlassian Bamboo' },
    ],
  },
  {
    id: 'leadership',
    nameKey: 'skills.categories.leadership',
    skills: [
      { name: 'Epic Leading' },
      { name: 'Feature Planning' },
      { name: 'Architectural Planning' },
      { name: 'ADRs' },
      { name: 'Technical Documentation' },
      { name: 'SCRUM' },
      { name: 'Code Reviews' },
      { name: 'Team Mentoring' },
      { name: 'Miro' },
    ],
  },
];
